import mapValues from 'lodash/mapValues';

import {Store} from './store';
import {User} from 'app_api/me/types';
import userDetailsClient from 'common/report/queries/app-api/user-details-client';

export interface UserDetails {
  email: string;
  id: number;
  isStaff: boolean;
  name: string;
  organizations: object;
  projects: object;
  workspaces: object;
}

export default new Store<UserDetails>({
  apiClient: userDetailsClient,

  transform: {
    index: (userDetails: User): UserDetails => ({
      email: userDetails.user_email,
      id: userDetails.user_id,
      isStaff: userDetails.is_staff,
      name: userDetails.user_name,
      organizations: userDetails.organizations,
      projects: mapValues(userDetails.projects, (project, id) => ({
        id: parseInt(id, 10),
        can_view_project_settings: project.permissions && project.permissions.includes(`access_project_settings`),
        ...project,
      })),
      workspaces: userDetails.workspaces,
    }),
  },

  defaultValue: {
    email: ``,
    isStaff: false,
    name: ``,
    organizations: [],
    projects: {},
    workspaces: {},
  },
});
